import logo from './img/logow.png';

export const images = [
    logo
];